import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from './Icon.js';
import { NumericInput } from './Field.js';
import { money } from '../lib/format.js';
import { useSalaryForm } from '../lib/salary-form.js';

/**
 * Atalho fixo para o salário-base nas telas que herdam o valor da calculadora.
 * Elas não têm mais campo próprio de salário: editar aqui refaz todos os cálculos.
 * Nasce aberto e só fecha no botão — clique fora não minimiza, senão o primeiro
 * toque em qualquer lugar da página desfaria o estado padrão.
 */
export function SalaryPill() {
  const [form, setForm] = useSalaryForm();
  const [open, setOpen] = useState(true);
  const root = useRef<HTMLDivElement>(null);
  const field = useRef<HTMLInputElement>(null);
  // Só foca ao expandir pela mão do usuário: no primeiro render roubaria o foco da página.
  const focusOnOpen = useRef(false);

  useEffect(() => {
    if (!open) return;
    if (focusOnOpen.current) {
      field.current?.focus();
      focusOnOpen.current = false;
    }
    const key = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && root.current?.contains(document.activeElement)) setOpen(false);
    };
    document.addEventListener('keydown', key);
    return () => document.removeEventListener('keydown', key);
  }, [open]);

  if (!open) {
    return (
      <div className="salary-pill" ref={root}>
        <button
          type="button" className="salary-pill-trigger glass-nav" aria-expanded={false}
          aria-label={`Salário-base de ${money(form.base)}. Abrir atalho`} title={`Salário-base: ${money(form.base)}`}
          onClick={() => { focusOnOpen.current = true; setOpen(true); }}
        >
          <Icon name="payments" size={22} fill />
        </button>
      </div>
    );
  }

  return (
    <div className="salary-pill open" ref={root}>
      <div className="salary-pill-panel glass-nav">
        <div className="salary-pill-head">
          <span><Icon name="payments" size={18} fill />Salário-base</span>
          <button type="button" className="salary-pill-close" aria-label="Minimizar atalho do salário" onClick={() => setOpen(false)}>
            <Icon name="close" size={18} />
          </button>
        </div>
        <span className="field-shell">
          <NumericInput
            ref={field} className="field numeric with-suffix" label="Salário-base mensal"
            value={form.base} onChange={(value) => setForm((current) => ({ ...current, base: value }))}
          />
          <span className="field-suffix">R$</span>
        </span>
        <p className="helper"><Icon name="info" size={16} />Vale para todas as telas que usam o salário.</p>
        <Link className="btn-secondary" to="/calculos/salario">
          <Icon name="tune" size={18} />Bônus, horas extras e descontos
        </Link>
      </div>
    </div>
  );
}
